
<!--
  ~ VNCcontact+ : A new level of contact management
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="help_faq_dialog contact-dialog">
  <div class="contact__dialog-header mobile_header">
    <div class="mobile-back-button">
      <button id="mobile_sidebar_about_faq_backbtn" mat-button (click)="close()">
          <mat-icon class="mdi-20px" fontSet="mdi" fontIcon="mdi-arrow-left"></mat-icon>
      </button>
    </div>
    <div id="mobile_sidebar_about_faq_header" class="header_lbl disable-select">
      {{ 'USER_MANUAL' | translate }}
    </div>
    <div class="desktop-close-button">
      <button mat-button (click)="close()">
        <mat-icon class="disable-select">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="contact__dialog-body contact__dialog-body--pad">
    <div class="content">
      <div class="help">
        <h6 id="mobile_sidebar_about_faq_helplbl" class="disable-select">{{ 'HELP_LABEL' | translate }}</h6>
        <span id="mobile_sidebar_about_faq_help_link" class="disable-select">{{ 'COMING_SOON_LBL' | translate }}</span>
      </div>
      <div class="manual">
        <h6 id="mobile_sidebar_about_faq_manuallbl" class="disable-select">{{ 'MANUAL_LABEL' | translate }}</h6>
        <a id="mobile_sidebar_about_faq_manuallink" class="open-new-window disable-select" href="{{userManual}}" target="_blank">
          {{userManual}}
        </a>
      </div>
      <div class="faq">
        <h6 id="mobile_sidebar_about_faq_faqlbl" class="disable-select">{{ 'FAQ_LABEL' | translate }}</h6>
        <a id="mobile_sidebar_about_faq_faqlink" class="open-new-window disable-select" href="{{faqURL}}" target="_blank">
          {{faqURL}}
        </a>
      </div>
    </div>
  </div>
</div>